import { useEffect, useMemo } from "react";
import JCaseCard from "./JCaseCard";
import Pagination from "../Util/Pagination";
import { parseAsInteger, useQueryState } from "nuqs";

const JCases = ({ cases, handleDeleteCase }) => {
  const casesSorted = cases
    .sort((a, b) => {
      return b.created_at?.localeCompare(a.created_at);
    })
    .sort((a, b) => {
      return b.fav - a.fav;
    });
  const [page, setPage] = useQueryState(
    "page",
    parseAsInteger.withDefault(0).withOptions({ history: "replace" })
  );
  function dividePages(arr) {
    const res = [];
    for (let index = 0; index < arr.length; index++) {
      const el = [];
      if (index % 5 === 0) {
        res.push(el);
      }

      let i = Math.floor(index / 5);
      res[i].push(arr[index]);
    }
    return res;
  }

  const paginatedCases = useMemo(
    () => dividePages(casesSorted),
    [casesSorted]
  );
  const pagesCount = paginatedCases.length;

  const handlePage = (e) => {
    const action = e.target.getAttribute("data-key");
    const lastIndex = Math.max(pagesCount - 1, 0);

    if (action === "next") {
      setPage((old) => Math.min(old + 1, lastIndex));
      return;
    }

    if (action === "end") {
      setPage(lastIndex);
      return;
    }

    if (action === "previous") {
      setPage((old) => Math.max(old - 1, 0));
      return;
    }

    if (action === "start") {
      setPage(0);
    }
  };

  useEffect(() => {
    if (pagesCount === 0) {
      return;
    }

    const lastPageIndex = pagesCount - 1;
    if (page > lastPageIndex) {
      setPage(lastPageIndex);
    }
  }, [page, pagesCount, setPage]);

  return (
    <article>
      {cases?.length ? (
        <>
          <h4 className="total-cases">
            Σύνολο Υποθέσεων: {casesSorted.length} - Όριο Υποθέσεων: 120
          </h4>

          <Pagination page={page} length={pagesCount} handlePage={handlePage} />

          {paginatedCases[page]?.map((singleCase, i) => {
            const {
              id,
              arkat,
              kwdikos,
              court,
              note,
              last_checked,
              created_at,
              katigoria,
              antikeimeno,
              tmima,
              synthesi,
              imnia_eisagwgis,
              dikasimos,
              diataktiko,
              apotelesma,
              fav,
            } = singleCase;
            return (
              <JCaseCard
                key={id}
                singleCase={{
                  i,
                  id,
                  arkat,
                  kwdikos,
                  court,
                  note,
                  last_checked,
                  created_at,
                  katigoria,
                  antikeimeno,
                  tmima,
                  synthesi,
                  imnia_eisagwgis,
                  dikasimos,
                  diataktiko,
                  apotelesma,
                  fav,
                }}
                handleDeleteCase={handleDeleteCase}
              />
            );
          })}
          <Pagination page={page} length={pagesCount} handlePage={handlePage} />
        </>
      ) : (
        <p>Δεν έχετε καταχωρήσει υπόθεση προς έλεγχο</p>
      )}
    </article>
  );
};

export default JCases;
